import { useContext } from "react";
import { ChangeLanguageContext } from "../contexts/LanguageContext";

export function useChangeLanguage() {
    return useContext(ChangeLanguageContext);
}